import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFractionsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "currentColor",
		fillRule: "evenodd",
		fillOpacity: .84,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M17.8571429,4.125 L20,6.53571429 L7.14285714,21 L5,18.5892857 L17.8571429,4.125 Z M16.5,15.375 C17.8807119,15.375 19,16.4942881 19,17.875 C19,19.2557119 17.8807119,20.375 16.5,20.375 C15.1192881,20.375 14,19.2557119 14,17.875 C14,16.4942881 15.1192881,15.375 16.5,15.375 Z M8.5,4 C9.88071187,4 11,5.11928813 11,6.5 C11,7.88071187 9.88071187,9 8.5,9 C7.11928813,9 6,7.88071187 6,6.5 C6,5.11928813 7.11928813,4 8.5,4 Z",
			id: "Combined-Shape"
		})
	})
});
export default SvgFractionsIcon;
